import axios from "axios";

export interface ViewsResponse {
  status: string;
  data: {
    views: View[];
  };
}

export interface View {
  _id: string;
  name: string;
  listOrder?: number;
}

export async function fetchViews() {
  const { data } = await axios.get<ViewsResponse>("/match/view");
  return data;
}

export interface ViewColumn {
  id: string;
  label: string;
  dataType: "string" | "double" | "date";
  outputFormat?: {
    thousandsSeparator?: string;
    decimalSeparator?: string;
    decimalPlaces?: number;
  };
}

export interface ViewRow {
  label: string;
  [metricId: string]: string;
}

export interface ViewGeneratedResponse {
  status: string;
  data: {
    columns: ViewColumn[];
    rows: ViewRow[];
  };
}

export interface DateRange {
  startDate: string;
  endDate: string;
}

export interface GenerateViewParams {
  dateRange?: DateRange;
}

export async function generateView(viewId: string, body?: GenerateViewParams) {
  const { data } = await axios.post<ViewGeneratedResponse>(
    `/match/view/${viewId}/generate`,
    body,
  );
  return data;
}

export interface DownloadViewResponse {
  status: string;
  data: {
    fileId: string;
  };
}

export async function downloadView(viewId: string, body?: GenerateViewParams) {
  const { data } = await axios.post<DownloadViewResponse>(
    `/match/view/${viewId}/download`,
    body,
  );
  return data;
}
